import React from 'react';

export default function PesoIcon() {
  return (
    <span
      aria-hidden="true"
      style={{
        alignItems: 'center',
        border: '2px solid currentColor',
        borderRadius: '50%',
        display: 'inline-flex',
        fontSize: '0.78em',
        fontWeight: 700,
        height: '1.15em',
        justifyContent: 'center',
        lineHeight: 1,
        width: '1.15em',
      }}
    >
      ₱
    </span>
  );
}
